// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"kOoppl4m31","breadcrumbs-container":"xlt2eaFLqb","breadcrumbsContainer":"xlt2eaFLqb"};
    if(module.hot) {
      // 1643570393062
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  